export const salesUnitsConfigQuery = /* GraphQL */ `
    query getSalesUnitsConfig {
        config {
            base {
                sales_units {
                    enable_sales_units
                    label_text
                    last_units
                }
            }
        }
    }
`

export type SalesUnitsConfigOutput = {
    config?: {
        base?: {
            sales_units?: {
                enable_sales_units?: boolean | null
                label_text?: string | null
                last_units?: number | null
            } | null
        } | null
    } | null
}
